<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.links')" />

          <router-link to="/admin/links/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <link-list-item :linkList="links" @update="fetchLinks" />
    </template>
  </div>
</template>

<script>
import LinkListItem from '@/components/Pages/Categories/LinkList.vue'

export default {
  components: { LinkListItem },
  data() {
    return {
      page: this.$route.query.page || 1,
      perPage: 10,
      numberOfPages: 1,
      apiBase: '/api/dashboard/homepage-link'
    }
  },
  computed: {
    apiUrl() {
      return `${this.apiBase}?page=${this.page}`
    },
    links() {
      return this.$store.getters['links/links']
    },
    isLoading() {
      return this.$store.getters['links/isLoading']
    }
  },
  async mounted() {
    await this.fetchLinks()
  },
  methods: {
    linkGen(pageNum) {
      return { query: { page: pageNum } }
    },
    fetchLinks() {
      this.$store.dispatch('links/fetchLinks', { vm: this })
    }
  }
  // watch: {
  //   apiUrl() {
  //     this.fetchLinks()
  //   }
  // }
}
</script>
